<template>
  <main class="checkout-success">
    <section class="checkout-success__panel">
      <img v-if="visuals.logo" :src="visuals.logo" :alt="visuals.name">
      <h1>{{ $t('checkout.success.title') }}</h1>
      <p>{{ $t('checkout.success.text') }}</p>
      <a href="/checkout">{{ $t('checkout.success.back') }}</a>
    </section>
  </main>
</template>

<script>
export default {
  computed: {
    visuals() {
      return this.$store.getters.visuals || {};
    },
  },
};
</script>

<style scoped>
.checkout-success {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7f8;
  padding: 20px;
  color: #17212b;
}
.checkout-success__panel {
  width: min(100%, 520px);
  background: #fff;
  border: 1px solid #dde3e8;
  border-radius: 8px;
  padding: 34px;
  text-align: center;
  box-shadow: 0 16px 40px rgba(25, 39, 52, .08);
}
.checkout-success img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 8px;
}
.checkout-success h1 {
  margin: 20px 0 10px;
  font-size: 32px;
  letter-spacing: 0;
}
.checkout-success p {
  color: #4c5a66;
  margin: 0 0 24px;
}
.checkout-success a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  border-radius: 6px;
  padding: 0 18px;
  background: #16794c;
  color: #fff;
  text-decoration: none;
}
</style>
